import React from 'react'

// Components
import { ModalRestrictor } from '@sketch/components'

// Local Components
import { CollectionItemGridView } from './CollectionItemGridView'
import { CollectionItemListView } from './CollectionItemListView'

// Types
import { CollectionPreviewsFragment } from '@sketch/gql-types'
import { RenderCollectionDropdown } from './types'

export const CollectionItemComponent = {
  Card: CollectionItemGridView,
  ListItem: CollectionItemListView,
}

interface CollectionItemProps {
  collection: CollectionPreviewsFragment
  projectIdentifier: string
  workspaceIdentifier: string
  onClick?: React.MouseEventHandler<HTMLElement>
  renderDropdown: RenderCollectionDropdown
  presentation: 'grid' | 'list'
}

const CollectionItem: React.FC<CollectionItemProps> = ({
  collection,
  projectIdentifier,
  workspaceIdentifier,
  presentation,
  onClick,
  renderDropdown,
}) => {
  const Component =
    presentation === 'grid'
      ? CollectionItemComponent.Card
      : CollectionItemComponent.ListItem

  return (
    <ModalRestrictor>
      <Component
        data-testid="collection-item"
        collection={collection}
        projectIdentifier={projectIdentifier}
        workspaceIdentifier={workspaceIdentifier}
        renderDropdown={() => renderDropdown(collection)}
        onClick={onClick}
      />
    </ModalRestrictor>
  )
}

export default CollectionItem
